<template>
  <div>
    <el-menu text-color="#666666" background-color="#E4E7ED"  active-text-color="#409EFF" unique-opened="true" router="true">
      <div v-for="(val,key) in menu" v-bind:key="key">
        <!-- 没有了菜单 -->
        <div v-if="!val.sub_menu">
          <el-menu-item :index="val.path">
            <template slot="title">
              <i class="layer-menu-icon iconfont color-white" :class="val.icon"></i>
              <span>{{val.name}}</span>
            </template>
          </el-menu-item>
        </div>
        <!-- 有子菜单 -->
        <div v-if="val.sub_menu">
          <el-submenu :index="key">
            <div slot="title">
              <i class="layer-menu-icon iconfont color-white" :class="val.icon"></i>
              <span>{{val.name}}</span>
            </div>
            <div v-for="(sval,skey) in val.sub_menu" v-bind:key="skey">
              <el-menu-item :index="sval.path">{{sval.name}}</el-menu-item>
            </div>
          </el-submenu>
        </div>
      </div>
    </el-menu>
  </div>
</template>

<script>
export default {
  name: "menu",
  data (){
    return {
      menu : [
          {name:'首页管理',path:'index',icon:'icon-home'},
          {name:'用户管理',path:'user',icon:'icon-people'},
          {name:'管理人员',path:'admin',icon:'icon-peoplelist'},
          {name:'充值设置',path:'recharge',icon:'icon-setting'},
          {name:'开通设置',path:'rule',icon:'icon-setting'},
          {name:'申请管理',path:'join',icon:'icon-form'},
          {name:'单页管理',path:'one_page',icon:'icon-read'},
          {name:'电子书页',path:'ebook',icon:'icon-read1'},
          {name:'VIP列表',path:'vip_list',icon:'icon-vip'},
          {name:'充值记录',path:'deposit_list',icon:'icon-recharge'},
          {name:'容量记录',path:'media_list',icon:'icon-record'},
      ]
    }
  },
  mounted() {

  }
}
</script>

<style scoped>
.el-menu { border-right: none; }
.el-menu-item { font-size: 15px; }
.layer-menu-icon { padding-right: 15px; font-size: 18px;}
</style>